'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4;

import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIImage from 'UIComponents/image/UIImage';
import QUESTION_BACKGROUND_IMAGE from 'bender-url!pricing-pages-unified-ui/img/bottom-blob.svg';
import breakpoint from '../../utils/responsiveBreakpoints';
import React, { createContext, useState } from 'react';
import { useTranslations } from '../../hooks/useTranslations';
import faqsAnswersTranslations from 'i2l?query=sporks!pricing-pages-unified-ui/lang/faqsAnswers/en.lyaml';
export const FaqsAnswersTranslationsContext = /*#__PURE__*/createContext(null);
const StyledQuestionBackground = styled(UIImage).withConfig({
  displayName: "Faq__StyledQuestionBackground",
  componentId: "sc-137qlqw-0"
})(["position:absolute;top:0;width:100%;max-height:100%;", ";"], breakpoint.phone(_t || (_t = _`
    display: none !important;
  `)));
const QuestionContainer = styled.div.withConfig({
  displayName: "Faq__QuestionContainer",
  componentId: "sc-137qlqw-1"
})(["width:1000px;margin-right:auto;margin-left:auto;position:relative;margin-top:60px;padding-top:55px;padding-bottom:95px;clear:both;", ";", ";"], breakpoint.cs(_t2 || (_t2 = _`
    width: 800px;
  `)), breakpoint.tabletPortrait(_t3 || (_t3 = _`
    width: initial;
  `)));
const QuestionContent = styled.div.withConfig({
  displayName: "Faq__QuestionContent",
  componentId: "sc-137qlqw-2"
})(["z-index:1;position:relative;"]);
const Title = styled.h1.withConfig({
  displayName: "Faq__Title",
  componentId: "sc-137qlqw-3"
})(["font-weight:bold;line-height:44px;text-align:center;margin-top:0;margin-bottom:35px;", ";"], breakpoint.phone(_t4 || (_t4 = _`
    text-align: left;
    margin: 35px 0;
  `)));

const Faq = ({
  children
}) => {
  const [shouldLoadTranslations, setShouldLoadTranslations] = useState(false);
  const {
    isReady
  } = useTranslations(faqsAnswersTranslations, shouldLoadTranslations);

  const handleLoadTranslations = () => {
    if (!shouldLoadTranslations) {
      setShouldLoadTranslations(true);
    }
  };

  const childrenWithProps = React.Children.map(children, child => {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        onQuestionClick: handleLoadTranslations
      });
    }

    return child;
  });
  return /*#__PURE__*/_jsxs(QuestionContainer, {
    "data-selenium-id": "faq-container",
    children: [/*#__PURE__*/_jsx(StyledQuestionBackground, {
      src: QUESTION_BACKGROUND_IMAGE
    }), /*#__PURE__*/_jsxs(QuestionContent, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.faq.title"
        })
      }), /*#__PURE__*/_jsx(FaqsAnswersTranslationsContext.Provider, {
        value: {
          isReady
        },
        children: childrenWithProps
      })]
    })]
  });
};

Faq.propTypes = {
  children: PropTypes.node.isRequired
};
export default Faq;